export default __webpack_public_path__ + "static/eleven-ab417ee229b4661dd96881afa4be9acd.png";